import mapper from '../mapper/index.js';

function updateGeo(state, geo) {
    state.geo = Object.assign(state.geo, mapper.geo(geo));
}

export default {
    updateGeo,
};
